import React from 'react';
import { ProgressBar } from "./StudentDasbordData";
import helpers from '../utils/helpers';
import fallBackImage from '../Assests/images/placeholderimage.jpg'

const StudentApplicationTable = ({ applications, headers, loader }) => {




    return (
        <div className="p-2 max-h-[300px] overflow-y-auto scrollbar-hide">

            <div className="overflow-x-auto">
                <table className="w-full text-left bg-white rounded-xl shadow-md">
                    {/* Dynamic header */}
                    <thead>
                        <tr className="border-b text-gray-500 font-semibold">
                            {headers.map((h, index) => (
                                <th key={index} className="py-3 px-4 text-[#283C50]">
                                    {h.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {loader ?
                            <td colSpan={6}>
                                <div className="h-[250px] flex items-center justify-center">
                                    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
                                </div>
                            </td>
                            :
                            (applications && applications.length > 0) ? applications.map((app, index) => {
                                // const IconComponent = app.icon;
                                return (
                                    <tr onClick={() => window.location.href = `/myapplications/${helpers.encryptId(app?.application_id)}`} key={index} className="bg-white cursor-pointer rounded-xl shadow-sm hover:shadow-md transition">
                                        {/* Application */}
                                        <td className="py-3 px-4 flex items-center space-x-3">
                                            <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center">
                                                {/* <IconComponent className="w-6 h-6 text-indigo-500" /> */}
                                                <img src={app?.icon || fallBackImage} alt={app?.app_name} className='w-10 h-10 rounded-lg object-cover'
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = fallBackImage;
                                                    }}
                                                />
                                            </div>
                                            <span className="font-medium text-[#717576]">{app?.app_name}</span>
                                        </td>

                                        {/* Educator */}
                                        <td className="py-3 px-4">
                                            <div className="flex items-center space-x-3">
                                                <img
                                                    src={app?.profile_pic || fallBackImage}
                                                    alt={app?.full_name}
                                                    className="w-10 h-10 rounded-full object-cover border border-gray-200"
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = fallBackImage;
                                                    }}
                                                />
                                                <div className="flex flex-col">
                                                    <span className="font-medium text-[#717576]">{app?.full_name}</span>
                                                    <span className="text-xs text-[#717576]">ID: {app?.educator_id}</span>
                                                </div>
                                            </div>
                                        </td>

                                        {/* Avg Score */}
                                        <td className="py-3 px-4 text-primary-600 ">{app?.avr_score}</td>

                                        {/* Location */}
                                        <td className="py-3 px-4 text-[#717576]">{app?.location}</td>

                                        {/* Usage Hours */}
                                        <td className="py-3 px-4 text-[#717576]">{app?.usage_hours}</td>

                                        {/* Completion */}
                                        <td className="py-3 px-4">
                                            <div className="flex items-center space-x-2">
                                                <div className="w-32">
                                                    <ProgressBar percentage={app?.completion_score} />
                                                </div>
                                                <span className="font-semibold text-[#717576]">{app?.completion_score}</span>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            }) :
                                <td colSpan='6'>
                                    <div className="text-center h-[230px] content-center">
                                        <p className="text-gray-400 text-sl">There are currently no applications.</p>
                                    </div>
                                </td>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default StudentApplicationTable;
